module.exports = __webpack_public_path__ + "static/media/sample_lmfreights.c759ec14.csv";